module.exports = __webpack_public_path__ + "static/movil-web-87535b90db51e28e40da2f36174703aa.svg";